<template>
  <div class="flota page-view">
    <div v-if="this.isFilterActive" style="text-align: center; margin-bottom: 5px;"><span class=filter-date>{{ this.filter.startDate }}</span><span class=filter-time> ({{ this.filter.startTime }}) </span><span class=filter-separator> - </span><span class=filter-date>{{ this.filter.endDate }}</span><span class=filter-time> ({{ this.filter.endTime }})</span><div style="margin-top: 10px;" @click="this.onFilterClear"><img src='img/remove.png' width="24" height="24" /></div></div>
    <ejs-grid ref='grid' :dataSource="this.$store.state.cars" :rowSelected='rowSelected' :rowDeselected='rowDeselected' cssClass="flota-list" :allowTextWrap="true">
      <e-columns>
        <e-column  v-if="!this.isFilterActive" headerText='Status' :template='status_vozilaTemplate' width=80 textAlign='Center'></e-column>
        <e-column headerText='Vozilo' :template='ime_vozilaTemplate' textAlign='Left'></e-column>
        <e-column headerText='Kategorija' :template='kategorija_vozilaTemplate' textAlign='Center'></e-column>
        <e-column  v-if="!this.isFilterActive" headerText='Vrijeme' :template='startReturnInfoTemplate' textAlign='Right'></e-column>
      </e-columns>
    </ejs-grid>
    <p style="font-size: 0.8rem; text-align: center;">Ukupno vozila: {{ brojVozila }} </p>
    <div  id=car-add-icon v-bind:class="{ transparent: this.isScrolling }" @click="onAdd">
      <img class=custom-icon-shadow src='img/plus.png' width="50" height="50"/>
    </div>
    <div id=car-search-icon v-bind:class="{ transparent: this.isScrolling }" @click="onSearch">
      <img class=custom-icon-shadow  src='img/search.png' width="50" height="50"/>
    </div>

    <div id=row-icons>
      <img class=custom-icon-shadow src='img/list.png' width="36" height="36" @click="onForward" v-bind:class="{ hidden: !this.selectedCarID }"/>
      <img class=custom-icon-shadow src='img/edit.png' width="36" height="36" @click="onEdit" v-bind:class="{ hidden: !this.selectedCarID, transparent: this.isScrolling }"/>
      <img class=custom-icon-shadow src='img/refresh.png' width="36" height="36" @click="onRefresh" v-bind:class="{ hidden: !this.selectedCarID, transparent: this.isScrolling }"/>
      <img class=custom-icon-shadow src='img/remove.png' width="36" height="36" @click="onDeleteClick" v-bind:class="{ hidden: !this.selectedCarID, transparent: this.isScrolling }"/>
    </div>
    
    <div class=hidden>
      <ejs-datepicker ref='startDate'  :format="dateFormat" width="300" :close="this.onStartDateClose"></ejs-datepicker>
      <ejs-timepicker ref='startTime' :format="timeFormat" :step="timeStep" width="300" :min="this.minTime" :max="this.maxTime" :close="this.onStartTimeClose"></ejs-timepicker>
      <ejs-datepicker ref='endDate'  :format="dateFormat" width="300" :close="this.onEndDateClose" :min="this.minimunEndDate"></ejs-datepicker>
      <ejs-timepicker ref='endTime' :format="timeFormat" :step="timeStep" width="300" :min="this.minTime" :max="this.maxTime" :close="this.onEndTimeClose"></ejs-timepicker>
    </div>
  </div>
</template>

<style lang="scss">
.hidden {
  display: none;
}

.filter-date {
  font-weight: bold;
  font-size: 1.1rem;
}

.filter-time {
  font-style: italic;
  font-size: 0.9rem;
}

.filter-separator {
  font-weight: lighter;
  font-size: 1.1rem;
}

.flota {
  margin-bottom: 60px;
}

#car-add-icon {
  position: fixed;
  right: 25px;
  bottom: 35px;
  transition: 0.3s ease-out opacity;
}

#car-search-icon {
  position: fixed;
  left: 25px;
  bottom: 35px;
  transition: 0.3s ease-out opacity;
}

#row-icons {
  z-index: 1000;
  width: auto;
  height: auto;
  margin: 0;
  position: fixed;
  right: 32px;
  bottom: 100px;
}

#row-icons img {
  display: block;
  margin-bottom: 15px;
}

#row-icons img.hidden {
  transform: translateX(280px);
}

@media only screen and (max-height: 360px) {
  #row-icons img {
    display: inline;
    margin-left: 15px;
  }
}

#row-icons img:nth-child(1) {
  transition: 0.4s ease-in-out transform;
}

#row-icons img:nth-child(2) {
  transition: 0.5s ease-in-out transform;
}

#row-icons img:nth-child(3) {
  transition: 0.6s ease-in-out transform;
}

#row-icons img:nth-child(4) {
  transition: 0.7s ease-in-out transform;
}

.transparent {
  opacity: 0.1;
}

.car-name {
  display: block;
  font-weight: 500;
  font-size: 1.1rem;
}

.car-plate {
  display: block;
  font-size: 0.8rem;
  font-weight: 200;
}

.car-status {
  height: 36px;
  width: 36px;
  border-radius: 100%;
  margin: auto;
  p {
    margin: 0;
    text-align: center;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    font-weight: 500;
    font-size: 20px;
  }
}

.car-status.status-free {
  background-color: #2edb9b;
}

.car-status.status-rent {
  background-color: #ff4400;
}

.car-status.status-reserved {
  background-color: #ffdd00;
}

.status-time {
  span {
    display:block;
  }

  .return-days {
    font-weight: 600;
  }

  .return-time {
    font-weight: 300;
  }
}

.return-days-delay {
  color: red;
}
</style>

<script>
import Vue from 'vue';

export default {
  name: 'main_page',
  data() {
    return {
      isScrolling: false,
      scrollDelay: null,
      selectedCar: null,
      dateFormat : 'dd.MM.yyyy',
      timeFormat : 'HH:mm',
      timeStep : 15,
      minTime: new Date(2020, 3, 8, 5, 0),
      maxTime: new Date(2020, 3, 8, 21, 0),
      ime_vozilaTemplate() {
          return { 
            template : Vue.component('ime_vozilaTemplate', {
                        template: `<div><span class=car-name>{{ this.data.ime_vozila}}</span><span class=car-plate>{{ this.data.registracijska_oznaka}}</span></div>`,
                        data() {
                          return {
                            data: {},
                          }
                        }
                      })
          }
      },
      kategorija_vozilaTemplate() {
          return { 
            template : Vue.component('kategorija_vozilaTemplate', {
                        template: `<div><span class=car-category>{{ this.data.categoriesName}}</span></div>`,
                        data() {
                          return {
                            data: {},
                          }
                        }
                      })
          }
      },
      status_vozilaTemplate() {
        return { 
          template : Vue.component('status_vozilaTemplate', {
                      template: `<div class='car-status' v-bind:class="{ 'status-free': this.statusFree, 'status-rent': this.statusRent, 'status-reserved': this.statusReserved }"><p>{{ this.statusText }}</p></div>`,
                      data() {
                        return {
                          data: {}
                        }},
                        computed: {
                          statusText() {
                            if (this.data.available == '0') return 'S';
                            if (this.data.available == '1') return 'N';
                            if (this.data.available == '2') return 'R';
                            return '';
                          },
                          statusFree() {
                            if (this.data.available == '0') return true;
                            return false;
                          },
                          statusRent() {
                            if (this.data.available == '1') return true;
                            return false;
                          },
                          statusReserved() {
                            if (this.data.available == '2') return true;
                            return false;
                          }
                        }
                    })
        }
      },
      startReturnInfoTemplate() {
        return { 
          template : Vue.component('startReturnInfoTemplate', {
                      template: `<div class=status-time><span class=return-days v-bind:class="{ 'return-days-delay': this.isDelay }">{{this.days}}</span><span class=return-time>{{this.time}}</span></div>`,
                      data() {
                        return {
                          data: {
                          }
                        }},
                        computed: {
                          isDelay() {
                            const d = this.days;  
                            return d.includes('-');   
                          },
                          days() {
                            const now = new Date();
                            let today, returnDate, reservationDate;
                            let car = this.data;
                            let result = '/';

                            if (car.available === "1") {
                              let carReturnDate = car.returnDate;
                              const crd = carReturnDate.split('.');   //dd.mm.yyyy
                              if (crd.length !== 3) return '-';
                              today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
                              returnDate = new Date(parseInt(crd[2]), parseInt(crd[1])-1, parseInt(crd[0]), 0, 0, 0, 0);
                              const ONE_DAY = 1000 * 60 * 60 * 24;
                              let difference_ms = returnDate.getTime() - today.getTime();
                              result = Math.round(difference_ms/ONE_DAY);
                            }

                            if (car.available === "2") {
                              let carReservationDate = car.reservationDate;
                              const crd = carReservationDate.split('.');   //dd.mm.yyyy
                              if (crd.length !== 3) return '-';
                              today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
                              reservationDate = new Date(parseInt(crd[2]), parseInt(crd[1])-1, parseInt(crd[0]), 0, 0, 0, 0);
                              const ONE_DAY = 1000 * 60 * 60 * 24;
                              let difference_ms = reservationDate.getTime() - today.getTime();
                              result = Math.round(difference_ms/ONE_DAY);
                            }
                            
                            if (result == 1 || result == -1) return result + " dan";
                            if (result > 1 || result == 0 || result < 0) return result + " dana";
                            return result;
                          },
                          time() {
                            let car = this.data;
                            if (car.available === "1") return car.returnTime;
                            if (car.available === "2") return car.reservationTime;
                            return '';
                          }
                        }
                    })
        }
      },
      isFilterActive: false,
      filter: {
        startDate: undefined,
        startTime: undefined,
        endDate: undefined,
        endTime: undefined
      },
    }},
  mounted() {
    this.$store.dispatch('getCars').catch(err => this.$parent.showNotification(err));
    if (this.$store.state.categories === null) this.$store.dispatch('getCategories').catch(err => this.$parent.showNotification(err));
    this.$store.state.currentView = 'flota';
    this.$store.state.previousView = null;
    this.$store.state.viewTitle = 'Flota';
    this.$store.state.hideSettingIcon = false;
    this.$store.state.hideCloseIcon = true;
    this.$store.state.hideReturnIcon = true;
    this.$store.state.hideFloatWidgetRight = true;
  },
  computed: {
    brojVozila() {
      if (this.$store.state.cars) {
        if (this.$store.state.cars.length) return this.$store.state.cars.length;
      }
      return 0;
    },
    selectedCarID() {
      if (this.selectedCar) return this.selectedCar.ID;
      else return 0;
    },
    minimunEndDate() {
      if (!(this.filter.startDate)) return new Date();
      const d = this.filter.startDate.split('.');
      if (d.length !== 3) return new Date();
      return new Date(parseInt(d[2]), parseInt(d[1])-1, parseInt(d[0]));
    }
  },
  methods: {
    onAdd() {
      this.$store.state.selectedCar = null;     //clear selected car in store
      this.$router.push('vozilo');
    },
    onSearch() {
      this.resetSearchFields();
      this.$refs.startDate.show();    //show start date calendar
    },
    rowSelected(args) {
       this.selectedCar = args.data;
       this.$store.state.selectedCar = this.selectedCar;
    },
    rowDeselected() {
       this.selectedCar = null;
       this.$store.state.selectedCar = this.selectedCar;
    },
    onWindowScroll() {
      this.isScrolling = true;
      clearInterval(this.scrollDelay); 
      this.scrollDelay = setTimeout(()=> {
        this.isScrolling = false;
      }, 100);
    },
    onForward() {
      this.$router.push('rezervacije');
    },
    onEdit() {
      this.$router.push('vozilo');
    },
    async onRefresh() {
      await this.$store.dispatch('refreshCar', this.selectedCar.ID).then(res => this.$parent.showNotification(res)).catch(err => this.$parent.showNotification(err));
      this.$store.dispatch('getCars').catch(err => this.$parent.showNotification(err));
    },
    onDeleteClick() {
      this.$parent.showPopup(this, 'Želite li obrisati vozilo: ' + this.selectedCar.ime_vozila + " (" + this.selectedCar.registracijska_oznaka +")");
    },
    async onDelete() {
      await this.$store.dispatch('deleteCar', this.selectedCar.ID).then(res => this.$parent.showNotification(res)).catch(err => this.$parent.showNotification(err));
      this.$store.dispatch('getCars').catch(err => this.$parent.showNotification(err));
    },
    onStartDateClose() {
      this.filter.startDate = this.$refs.startDate.$el.value || undefined;      //assign
      if (this.filter.startDate) this.$refs.startTime.show();                   //time picker
      
    },
    onStartTimeClose() {
      this.filter.startTime = this.$refs.startTime.$el.value || undefined;      //assign
      if(this.filter.startTime) this.$refs.endDate.show();                      //calendar
    },
    onEndDateClose() {
      this.filter.endDate = this.$refs.endDate.$el.value|| undefined;           //assign
      if(this.filter.endDate) this.$refs.endTime.show();                        //time picker
    },
    onEndTimeClose() {
      this.filter.endTime = this.$refs.endTime.$el.value || undefined;          //assign
      if (this.filter.endTime) {
        this.isFilterActive = true;
        this.$store.dispatch('searchCars', this.filter).then(r => this.$parent.showNotification(r)).catch(err => this.$parent.showNotification(err));
      }
    },
    onFilterClear() {
      this.$store.dispatch('getCars').catch(err => this.$parent.showNotification(err));
      this.filter.startDate = undefined;
      this.filter.startTime = undefined;
      this.filter.endDate = undefined;
      this.filter.endTime = undefined;
      this.resetSearchFields();
      this.isFilterActive = false;
      
    },
    resetSearchFields() {
      this.$refs.startDate.ej2Instances.value = null;
      this.$refs.startDate.$el.value = null;
      this.$refs.startTime.$el.value = null;
      this.$refs.endDate.$el.value = null;
      this.$refs.endDate.ej2Instances.value = null;
      this.$refs.endTime.$el.value = null;
    }
  }
}
</script>